export const copy = {
  whoIsPracticing: 'Wie gaat er oefenen?',
  tapYourName: 'Tik op je naam om te beginnen.',
  parents: 'Voor ouders',
  home: 'Naar het begin',
  group: (schoolGroup: number) => `Groep ${schoolGroup}`,
  stop: 'Stoppen',
  back: 'Terug',

  subjectsTitle: 'Waar ga je vandaag mee oefenen?',
  noSubjects: 'Er zijn nog geen vakken om te oefenen voor deze groep. Kom snel terug!',
  dailyGoal: (completed: number, target: number) => {
    const left = target - completed;
    return left <= 0
      ? 'Je doel van vandaag is gehaald. Knap!'
      : `Nog ${String(left)} ${left === 1 ? 'activiteit' : 'activiteiten'} voor je doel van vandaag`;
  },
  stillBusy: 'Je was nog bezig',
  questionsLeft: (left: number) => (left === 1 ? 'nog 1 vraag' : `nog ${String(left)} vragen`),
  carryOn: 'Verder',
  newRoundQuestion:
    'Weet je zeker dat je je huidige oefening wilt afsluiten en een nieuwe wilt starten?',
  newRoundYes: 'Ja, nieuwe oefening',
  keepGoing: 'Nee, verder oefenen',
  levels: { easy: 'Makkelijk', medium: 'Normaal', hard: 'Moeilijk' },
  levelHints: {
    easy: 'Om op te warmen',
    medium: 'Precies goed',
    hard: 'Voor echte kanjers',
  },
  chooseTopic: 'Kies een onderwerp',
  chooseLevel: 'Kies je niveau',
  levelLater: 'Binnenkort beschikbaar!',
  levelAgain: 'Elke keer nieuwe vragen',
  testTitle: 'Toets',
  testText: '20 vragen over alles door elkaar. Aan het eind zie je je score.',
  startTest: 'Toets maken',
  noTopics: 'Er zijn nog geen onderwerpen om te oefenen. Maak gerust de toets!',

  practice: 'Oefenen',
  practiceDetail: '10 vragen',
  practiceDescription: 'Je ziet meteen of het goed is, met uitleg erbij.',
  test: 'Toets',
  testDetail: '20 vragen',
  testDescription: 'Laat zien wat je al kunt. Aan het eind zie je je score.',
  resume: (answered: number, total: number) => `Verder waar je was (${answered} van ${total})`,
  startOver: 'Opnieuw beginnen',
  inProgress: 'Je was nog bezig',

  toGo: (count: number) => `${count} te gaan`,
  check: 'Controleer',
  next: 'Volgende',
  finish: 'Klaar!',
  explanation: 'Uitleg',
  correct: 'Goed zo!',
  incorrect: 'Bijna!',
  rightAnswer: 'Het goede antwoord is',
  typeAnswer: 'Typ je antwoord',
  dragHint: 'Sleep of tik om te verplaatsen',
  matchHint: 'Tik op een woord en daarna op het vakje waar het bij hoort.',
  empty: 'Nog leeg',
  moveUp: 'Omhoog',
  moveDown: 'Omlaag',

  readCarefully: 'Lees de tekst goed. Daarna krijg je vragen over de tekst.',
  readOn: 'Lees verder',
  smallerText: 'Kleinere letters',
  largerText: 'Grotere letters',

  roundDone: 'Ronde klaar!',
  testDone: 'Toets klaar!',
  score: (correct: number, total: number) => `Je hebt ${correct} van de ${total} goed.`,
  anotherRound: 'Nog een ronde',
  otherSubject: 'Ander vak kiezen',
  goalReached: 'Goed gedaan! Je hebt het doel van vandaag gehaald.',
  goalReachedTitle: 'Doel gehaald!',
  goalReachedShort: 'Je doel van vandaag is gehaald!',
  starEarned: 'Je hebt een ster verdiend!',
  bonusStar: 'Een extra ster! Je doel had je vandaag al gehaald.',
  starsLabel: (earned: number, target: number) =>
    `${String(earned)} ${earned === 1 ? 'ster' : 'sterren'} verdiend, doel is ${String(target)}`,
  keepPracticing: 'Verder oefenen',

  report: {
    open: 'Er klopt iets niet',
    sent: 'Gemeld, dank je!',
    title: 'Klopt er iets niet?',
    intro: 'Vertel ons wat er mis is. Dan kijken we de vraag na.',
    question: 'Wat klopt er niet?',
    reasons: {
      wrong_answer: 'Het goede antwoord klopt niet',
      unclear: 'Ik snap de vraag niet',
      typo: 'Er staat een foutje in',
      other: 'Iets anders',
    },
    noteLabel: 'Wil je nog iets vertellen?',
    notePlaceholder: 'Dit mag je leeg laten',
    send: 'Versturen',
    cancel: 'Annuleren',
    thanksTitle: 'Dank je wel!',
    thanks: 'We kijken de vraag na. Je kunt gewoon verder oefenen.',
    done: 'Verder oefenen',
  },
  roundGone: 'Deze ronde is gestopt. Begin gerust een nieuwe.',
  games: 'Spelletjes',
  chooseGame: 'Kies een spelletje!',
  noGames: 'Er staan nu geen spelletjes aan voor jouw groep. Kom snel terug!',
  gameOff: 'Dit spelletje staat nu uit.',
  gameOffHint: 'Je kunt wel gewoon oefenen. Wat je al gespeeld hebt, blijft bewaard.',
  toGames: 'Naar Spelletjes',
  toSubjects: 'Naar de vakken',
  gamesResting: 'De spelletjes rusten even. Zullen we samen oefenen?',
  noAccess: 'Oefy is nog niet actief voor jullie gezin. Vraag je ouder om Oefy te verlengen.',
  noPlace: 'Oefy staat nog niet aan voor jou. Vraag je ouder om een abonnement te kiezen.',
  newSchoolYearTitle: 'Een nieuw schooljaar!',
  newSchoolYearText: (who: string, count: number) =>
    `Ouders: geef even door in welke groep ${who} nu ${count === 1 ? 'zit' : 'zitten'}.`,
  newSchoolYearAction: 'Doorgeven',
  somethingWrong: 'Oeps, dat ging mis. Probeer het nog een keer.',
  tryAgain: 'Probeer opnieuw',

  worm: {
    name: 'Oefy de worm',
    pickChild: 'Hoi! Tik op je naam, dan gaan we samen oefenen.',
    welcome: (name: string) => `Hoi ${name}! Kies een vak of spelletje om te beginnen.`,
    resume: (subject: string) => `Je was nog bezig met ${subject}. Tik op Verder om door te gaan.`,
    goalAlmost: 'Nog één activiteit en je hebt je doel van vandaag gehaald!',
    goalDone: 'Je doel van vandaag is al gehaald. Nog meer oefenen mag altijd!',
    goalProud: 'Wat ben ik trots op je! Oefen gerust nog even verder.',
    chooseTopic: 'Kies een onderwerp om te oefenen. Of maak de toets!',
    chooseLevel: 'Begin gerust makkelijk. Gaat het goed? Kies dan een moeilijker niveau.',
    chooseLevelAgain: 'Elke keer dat je oefent, krijg je nieuwe vragen. Kies maar een niveau!',
    roundStopped: 'Deze oefening is gestopt. Kies gerust een nieuwe.',
    hint: 'Tip',
    anotherHint: 'Nog een tip',
    hintThinking: 'Even nadenken…',
    hintRest: 'Probeer het nu eerst zelf. Je kunt het!',
    hintFailed: 'Lees de vraag nog eens rustig. Wat wordt er precies gevraagd?',
    practiceStart: (topic: string, level: string) =>
      `Daar gaan we: ${topic}, niveau ${level}. Lees elke vraag rustig.`,
    testStart: 'Dit is de toets. Doe je best! Aan het eind zie je je score.',
    halfway: 'Je bent al op de helft. Goed bezig!',
    lastQuestion: 'Dit is de laatste vraag. Zet ’m op!',
    onARoll: (count: number) => `Al ${String(count)} goed op rij! Lukt deze ook?`,
    freshStart: 'Nieuwe vraag, nieuwe kans. Neem rustig de tijd.',
    tips: {
      choice: [
        'Lees eerst alle antwoorden. Welke kun je al wegstrepen?',
        'Kijk goed naar elk antwoord voordat je kiest.',
      ],
      number: [
        'Reken het eerst uit en typ dan het getal.',
        'Reken in kleine stapjes. Dan gaat het makkelijker.',
      ],
      word: [
        'Zeg het woord zachtjes voor jezelf voordat je het typt.',
        'Denk aan de regel die bij dit woord hoort.',
      ],
      gap: [
        'Lees de hele zin. Welk woord past op de lege plek?',
        'Lees de zin eerst helemaal voordat je typt.',
      ],
      text: ['Typ je antwoord in het vakje.', 'Lees de vraag goed en typ dan je antwoord.'],
      order: [
        'Wat komt als eerste? Begin daar.',
        'Sleep of tik om alles op de goede plek te zetten.',
      ],
      match: [
        'Tik op een woord en daarna op het vakje dat erbij hoort.',
        'Begin met het paar dat je het zekerst weet.',
      ],
      reading: [
        'Kijk gerust nog eens in de tekst.',
        'Zoek in de tekst naar de woorden uit de vraag.',
      ],
    },
    correct: ['Dat klopt!', 'Goed gedaan!', 'Helemaal goed!', 'Top, dat is juist!'],
    correctStreak: (count: number) => `${String(count)} goed op rij! Je bent op dreef.`,
    correctWithHint: 'Goed zo! Met een tip lukte het. Knap dat je doorzette.',
    correctAfterMiss: 'Goed zo! Deze keer klopt het helemaal.',
    correctHard: 'Knap! En dat op moeilijk niveau.',
    correctLast: 'Goed! Dat was de laatste vraag.',
    incorrect: [
      'Bijna! Lees de uitleg, dan snap je hoe het zit.',
      'Dat was niet goed, maar van fouten leer je. Kijk even naar de uitleg.',
    ],
    incorrectAgain: 'Geeft niks. Lees de uitleg rustig, dan gaat de volgende beter.',
    incorrectAfterHint: 'Dat was een lastige! In de uitleg zie je hoe het moet.',
    closeNumber: 'Je zat er heel dichtbij! Kijk in de uitleg waar het net misging.',
    tooHigh: 'Jouw antwoord is te groot. In de uitleg zie je hoe je het uitrekent.',
    tooLow: 'Jouw antwoord is te klein. In de uitleg zie je hoe je het uitrekent.',
    closeWord: 'Bijna goed geschreven! Vergelijk jouw woord met het goede woord.',
    partlyOrdered: (right: number, total: number) =>
      `${String(right)} van de ${String(total)} stonden al op de goede plek. Kijk wat er anders moest.`,
    partlyMatched: (right: number, total: number) =>
      `${String(right)} van de ${String(total)} klopten al. Kijk welke nog anders moesten.`,
    reading: 'Je mag de tekst steeds opnieuw bekijken.',
    roundGreat: 'Wat een score! Probeer eens een moeilijker niveau.',
    roundGreatHard: 'Wat een score, en dat op moeilijk! Echt knap.',
    roundGood: 'Goed geoefend! Nog een rondje maakt je nog sterker.',
    roundTough: 'Dit was pittig. Probeer het nog eens, of kies een makkelijker niveau.',
    roundToughEasy: 'Dit was pittig. Oefen nog een rondje, dan gaat het steeds beter.',
    testGreat: 'Wat een mooie toets! Je kunt al heel veel.',
    testGood: 'Goed gedaan! Kijk welke vragen nog lastig waren.',
    testTough:
      'Dit was een moeilijke toets. Oefen de onderwerpen nog even en probeer het later opnieuw.',
  },
} as const;
